import type { Enums, Nullable, ProtocolType } from "../types";

export function getProtocolTypeColor(template: Nullable<ProtocolType | string>): Enums<"color"> {
	switch (template) {
		case "general":
			return "red";
		case "meeting":
			return "blue";
		case "negotiation":
			return "emerald";
		case "call-request":
			return "gray";
		default:
			return "indigo";
	}
}
